import React, { useState } from 'react'
import Pagination from '../../Pagination/Pagination'
import { Grid } from '@material-ui/core'
import ProgramCard from '../../Program/ProgramCard'

const ProgramGrid = ({
  programs,
  setProgramToEdit,
  setShowAddEditProgram,
  setProgramToDelete,
  setShowDeleteModal,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  return (
    <>
      {programs !== undefined && (
        <>
          <Grid container spacing={2}>
            {(rowsPerPage > 0
              ? programs.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : programs
            ).map((program, index) => (
              <Grid key={index} item xs={3}>
                <ProgramCard
                  program={program}
                  setProgramToEdit={setProgramToEdit}
                  setShowAddEditProgram={setShowAddEditProgram}
                  setProgramToDelete={setProgramToDelete}
                  setShowDeleteModal={setShowDeleteModal}
                />
              </Grid>
            ))}
          </Grid>

          <Pagination
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
            setPage={setPage}
            rows={programs}
            className="m-t-40"
          />
        </>
      )}
    </>
  )
}

export default ProgramGrid
